import configuratorPrintsHtml from './configuratorPrints.html';
import ConfiguratorPrintsMainShapeType from './stuff/configuratorPrintsMainShapeType';
import configuratorPrintsMainShapeParams from './stuff/configuratorPrintsMainShapeParams';
import CutModes from './../cutModes';
import ConfiguratorPrintsValidator from './configuratorPrintsValidator';

class configuratorPrintsController {
    constructor($scope, $timeout, $http, $window, configuratorService, ModalService, cartService, translateService, printsService) {
        'ngInject';

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$http = $http;
        this.$window = $window;
        this.service = configuratorService;
        this.modalService = ModalService;
        this.cartService = cartService;
        this.printsService = printsService;
        this.translate = translateService;

        this.materials = [];
        this.activeMaterial = null;
        this.materialSettings = {
            type: null,
            subType: null,
            size: null
        };
        this.lastProperMaterialSettings = null;

        this.printType = null;
        this.printTypes = {};

        this.ConfiguratorPrintsMainShapeType = ConfiguratorPrintsMainShapeType;
        this.mainShapes = [];
        for (const type of ConfiguratorPrintsMainShapeType) {
            if (!type.name) continue;

            let shape = {
                name: `configurator.mainShape.type.${type.name}`,
                type: type,
                available: true,
                image: `/assets/FE/js/configurator/images/main-shape/${type.name}.png`,
                imageMobile: `/assets/FE/js/configurator/images/main-shape/${type.name}.svg`,
                imageMobileActive: `/assets/FE/js/configurator/images/main-shape/${type.name}Active.svg`
            };

            this.mainShapes.push(shape);
        }
        this.activeMainShape = null;
        this.mainShape = {
            type: null,
            w: null,
            h: null
        };
        this.configuratorPrintsMainShapeParams = configuratorPrintsMainShapeParams;

        this.cutModes = [
            {
                type: CutModes.chain,
                name: 'configurator.cutMode.chain.desktop',
                mobile_name: 'configurator.cutMode.chain.mobile',
                available: true
            },
            {
                type: CutModes.laser,
                name: 'configurator.cutMode.laser.desktop',
                mobile_name: 'configurator.cutMode.laser.mobile',
                available: true
            },
            {
                type: CutModes.frez,
                name: 'configurator.cutMode.frez.desktop',
                mobile_name: 'configurator.cutMode.frez.mobile',
                available: true
            }
        ];

        this.primer = 1;

        this.comments = '';

        this.price = 0;
        this.currency = {
            symbol: null,
            symbol_placement: null
        };
        this.quantity = 1;
        this.shop_id = null;

        this.uploadFile = null;
        this.uploadProgress = 0;

        this.calculatingPrice = false;
        this.calculatingPriceTimeout = null;

        this.focusedParam = null;

        this.isReady = false;

        this.loaded = false;
        this.saving = false;
        this.error = false;
        this.success = false;
        this.errors = [];
    }

    $onInit() {
        this.service.setUserLogged();
    }

    $postLink() {
        this.$timeout(() => {
            this.$scope.$watch(
                () => this.isMobile,
                (isMobile, wasMobile) => {
                    if (wasMobile == isMobile) {
                        return;
                    }

                    // @todo
                },
                true
            );

            let validationParamsChangeModel = () => {
                return {'mainShapeType': this.mainShape.type, 'materialSettings': this.materialSettings}
            };

            this.$scope.$watch(validationParamsChangeModel,
                (newVal, oldVal) => {
                    if(this.mainShapeParam.validator) {
                        this.mainShapeParam.validator.setData(newVal);
                    }
                }, true);

            this.$scope.$watch(() => {
                return Object.values(this.materialSettings).map(material => material ? material.id : -1);
            }, (newVal, oldVal) => {
                if (!newVal) return;
                this.calculatePriceDebounce();
            }, true);

            let omitNextQuantityWatch = false;

            // Poniżej - ilość

            this.$scope.$watch(() => this.quantity, (newVal, oldVal) => {
                if (omitNextQuantityWatch) {
                    omitNextQuantityWatch = false;
                    return;
                }

                this.errors = [];

                if (newVal < 1) {
                    omitNextQuantityWatch = true;
                    this.quantity = 1;
                    this.calculatePriceDebounce();
                    return;
                };

                if (newVal > 9999) {
                    omitNextQuantityWatch = true;
                    this.quantity = 9999;
                    this.calculatePriceDebounce();

                    this.errors.push({
                        message: this.translate.t('configurator.errors.maximumQuantity', {quantity: '9999'}),
                        type: 'error'
                    });

                    return;
                };

                this.calculatePriceDebounce();
            });

            // Poniżej - kształt

            let unbindMainShapeWatch = null;

            const revertMainShapeChanges = (newVal, oldVal) => {
                unbindMainShapeWatch();

                if (oldVal) {
                    for (const property of Object.keys(oldVal)) {
                        if (property == 'type' || property == 'oldType') continue;

                        this.mainShape[property] = oldVal[property];
                    }
                }

                this.omitNextMainShapeWatch = true;

                unbindMainShapeWatch = this.$scope.$watch(
                    mainShapeChangeModel, mainShapeChangeCallback, true
                );
            };

            const mainShapeChangeModel = () => {
                if (!this.mainShape) return null;

                return this.mainShape;
            };

            const mainShapeChangeCallback = (newVal, oldVal) => {
                if (this.omitNextMainShapeWatch) {
                    this.omitNextMainShapeWatch = false;

                    return false;
                }

                if (!this.validateMainShape()) {
                    revertMainShapeChanges(newVal, this.lastProperMainShapeModel);

                    return false;
                }

                if (!this.validateMainShapeSize()) {
                    revertMainShapeChanges(newVal, this.lastProperMainShapeModel);
                    this.calculatePriceDebounce();

                    return false;
                } else {
                    const properModel = angular.copy(newVal);
                    this.lastProperMainShapeModel = properModel;
                }

                this.calculatePriceDebounce();
            };

            unbindMainShapeWatch = this.$scope.$watch(
                mainShapeChangeModel, mainShapeChangeCallback, true
            );

            // Poniżej - ustawienia materiału

            let unbindMaterialSettingsWatch = null;

            const revertMaterialSettingsChanges = (newVal, oldVal) => {
                unbindMaterialSettingsWatch();

                // Revert to old params
                console.log('!configuratorController::$watch materialSettings revert to old params:', this.materialSettings, this.lastProperMaterialSettings);
                this.materialSettings = angular.copy(this.lastProperMaterialSettings);
                this.activeMaterial = this.materialSettings.type;

                // Show to user old errors!
                this.omitNextMaterialSettingsWatch = true;

                unbindMaterialSettingsWatch = this.$scope.$watch(
                    materialSettingsChangeModel, materialSettingsChangeCallback, true
                );
            };

            const materialSettingsChangeModel = () => {
                if (!this.materialSettings) return null;

                return this.materialSettings;
            };

            const materialSettingsChangeCallback = (newVal, oldVal) => {
                if (newVal === oldVal || newVal === null || oldVal === null) {
                    console.log('%% configuratorController::$watch materialSettings not changed', newVal, oldVal);
                    return;
                }

                if (this.omitNextMaterialSettingsWatch) {
                    console.log('!configuratorController::$watch omit', newVal, oldVal);
                    this.omitNextMaterialSettingsWatch = false;
                }

                console.log('%% configuratorController::$watch materialSettings:', newVal, oldVal);

                this.errors = [];

                // Model validation
                if (!this.validateMainShapeSize()) {
                    console.log('!validation failed, revert', this.lastProperMaterialSettings);
                    revertMaterialSettingsChanges(newVal, this.lastProperMaterialSettings);
                    return false;
                } else {
                    const properModel = angular.copy(newVal);
                    this.lastProperMaterialSettings = properModel;
                    this.setPrintType();
                }
            };

            unbindMaterialSettingsWatch = this.$scope.$watch(
                materialSettingsChangeModel, materialSettingsChangeCallback, true
            );

            // Poniżej - druk

            const printParametersChangeModel = () => {
                return {'printType': this.printType, 'primer': this.primer}
            }

            const printParametersChangeCallback = (nv, ov) => {
                this.calculatePriceDebounce();
            };

            this.$scope.$watch(printParametersChangeModel, printParametersChangeCallback, true);

            // Poniżej - reszta

            this.loadMaterials();
            this.loadPrintTypes();
            this.initComplete();
            this.changeMainShapeType(this.mainShapes[0]);
        });
    }

    loadMaterials() {
        this.service.getMaterials().then((response) => {
            for (let material of response.data) {
                material.available = true;
                material.image = material.image.src || null;
            }

            // Usuwamy materiały które nie mają określonych trybów druku
            response.data = response.data.filter(material => {
                // Typy materiałów i grubości dla materiałów bez typów
                material.items = material.items.filter(materialItem =>
                    materialItem.items.length === 0 // Nie ma dzieci - grubość nie ma typów druku
                    || materialItem.availablePrintTypes
                    && Object.entries(materialItem.availablePrintTypes).length > 0
                    && Object.entries(materialItem.availablePrintTypes).find(([printType, available]) => available) // Musi mieć włączony co najmniej jeden tryb druku
                );
                // Rodzaje materiałów
                return material.items.length > 0 // Musi mieć podtyp
                        && material.availablePrintTypes
                        && Object.entries(material.availablePrintTypes).length > 0
                        && Object.entries(material.availablePrintTypes).find(([printType, available]) => available);  // Musi mieć włączony co najmniej jeden tryb druku
            });

            this.materials = response.data;

            const activeMaterialType = this.materials[0];

            this.changeMaterialType(activeMaterialType);
        });
    }

    loadPrintTypes() {
        this.printsService.getPrintModes().then(response => {
            this.printTypes = response;
            this.setPrintType();
        });
    }

    setPrintType() {
        const availablePrintTypes = this.availablePrintTypes;

        if (!availablePrintTypes) {
            this.printType = null;
            return;
        }

        if (this.printType && availablePrintTypes) {
            const validPrintType = availablePrintTypes.find(availablePrintType => availablePrintType.id === this.printType.id);
            if (!validPrintType) {
                this.printType = null;
            }
        }

        if (this.printType) {
            return;
        }

        this.printType = availablePrintTypes[0];
    }

    get availablePrintTypes() {
        if (!this.printTypes || Object.keys(this.printTypes).length === 0 || !this.materialSettings || !this.materialSettings.type && !this.materialSettings.subType) {
            return [];
        }

        let availablePrintTypes = [];
        const materialPrintTypes = this.materialSettings.subType ? this.materialSettings.subType.availablePrintTypes : this.materialSettings.type.availablePrintTypes;

        if (!materialPrintTypes) {
            return [];
        }

        for (const [printTypeValue, printTypeName] of Object.entries(this.printTypes)) {
            if (typeof (materialPrintTypes[printTypeValue]) !== 'undefined' && materialPrintTypes[printTypeValue] === true) {
                availablePrintTypes.push({id: printTypeValue, name: printTypeName});
            }
        }

        return availablePrintTypes;
    }

    changeMaterialType(material) {
        this.activeMaterial = material;

        const type = material;
        let subType = null;
        let size = null;

        if (material.items && material.items.length > 0) {
            if (material.items[0].items && material.items[0].items.length > 0) {
                let subTypeSize = this.getDefaultSubTypeAndSize(material.items);

                subType = subTypeSize.subType;
                size = subTypeSize.size;
            } else {
                size = this.getDefaultSize(material.items);
            }
        }

        this.materialSettings = {
            type: type,
            subType: subType,
            size: size
        };
    }

    changeMaterialSubType(material) {
        let materialSize = null;

        if (material.items && material.items.length > 0) {
            materialSize = material.items[0];

            this.materialSettings.size = materialSize;
        }
    }

    changeMaterialSize(size) {
        this.materialSettings.size = size;
    }

    getDefaultSubTypeAndSize(subTypes) {
        return {
            subType: subTypes[0],
            size: subTypes[0].items[0]
        };
    }

    getDefaultSize(sizes) {
        return sizes[0];
    }

    changeMainShapeType(shape) {
        if (shape.type === this.mainShape.type) return false;

        this.activeMainShape = shape;

        if (this.mainShape.type) {
            let oldParams = this.configuratorPrintsMainShapeParams.get(this.mainShape.type);

            for (const [property, value] of oldParams.defaults) {
                oldParams.defaults.set(property, this.mainShape[property]);
            }
        }

        // Get type defaults
        if (!this.configuratorPrintsMainShapeParams.has(shape.type)) return false;

        let params = this.configuratorPrintsMainShapeParams.get(shape.type);

        for (const [property, value] of params.defaults) {
            this.mainShape[property] = value;
        }

        this.mainShape.type = shape.type;
    }

    get mainShapeParam() {
        if (this.configuratorPrintsMainShapeParams.has(this.mainShape.type)) {
            return this.configuratorPrintsMainShapeParams.get(this.mainShape.type)
        }

        return null;
    }

    get isMobile() {
        return this.$window.innerWidth <= 720;
    }

    get localModel() {
        const {w, h, ...localMainShapeModel} = this.mainShape;

        localMainShapeModel.totalLength = this.mainShape.w + this.mainShape.w + this.mainShape.h + this.mainShape.h;
        localMainShapeModel.oryginalBbox = {
            width: this.mainShape.w,
            height: this.mainShape.h
        };

        return {
            mainShape: localMainShapeModel,
            cutMode: this.getCutMode(),
            material: this.materialSettings,
            primer: this.primer,
            printType: this.printType
        };
    }

    get mainShapeDimensions() {
        const originalBbox = this.mainShape.rawElement ? this.mainShape.rawElement.oryginalBbox : null;

        const bboxWidth = originalBbox ? originalBbox.width : 0;
        const bboxHeight = originalBbox ? originalBbox.height : 0;

        return {
            width: bboxWidth,
            height: bboxHeight
        };
    }

    get model() {
        const model = this.localModel;

        model.mainShape.name = this.translate.t(`configurator.mainShape.typeName.${model.mainShape.type.name}`);
        model.mainShape.width = this.mainShape.w.toFixed(0);
        model.mainShape.height = this.mainShape.h.toFixed(0);

        // model.name = this.translate.t(
        //     'configurator.productConfiguratorName',
        //     {
        //         'mainShapeName': this.translate.t(`configurator.mainShape.type.${model.mainShape.type.name}`),
        //         'width': model.mainShape.width,
        //         'height': model.mainShape.height,
        //         'materialName': model.material.type.name,
        //         'materialSubTypeName': (model.material.subType ? ', ' + model.material.subType.name : ''),
        //         'materialSizeName': model.material.size.name,
        //         'cutModeName': this.translate.t(`configurator.cutMode.${model.cutMode}.desktop`)
        //     }
        // );
        model.name = 'ConfiguratorPrint ' + model.mainShape.width + 'x' + model.mainShape.height + ' (' + Math.random().toString(36).substring(2,7) + ')';

        return model;
    }

    getCutMode() {
        switch (this.activeMainShape.type.name) {
            case 'Rect':
                return 'chain';
            case 'Other':
                if (this.activeMaterial.id === 46) { // Poliwęglan
                    return 'frez';
                }
                return 'laser';
        }
    }

    calculatePriceDebounce() {
        this.calculatingPrice = true;

        if (this.calculatingPriceTimeout) {
            this.$timeout.cancel(this.calculatingPriceTimeout);
            this.calculatingPriceTimeout = null;
        }

        this.calculatingPriceTimeout = this.$timeout(
            () => {
                this.calculatePrice();
            },
            1000
        );
    }

    calculatePrice() {
        if (!this.materialSettings.size) return false;

        this.service.getPrintsPrice(this.localModel, this.quantity).then(
            response => {
                this.price = response.data.price;
                this.currency = response.data.currency;
                this.shop_id = response.data.shop_id;
                this.calculatingPrice = false;
            },
            response => {
                console.log(`Error while calculating price!`);
            }
        );
    }

    uploaderProgress(result) {
        this.uploadProgress = result;
    }

    uploaderComplete(result) {
        console.log('configuratorPrints.component::uploaderComplete()');
        console.log(result);

        this.uploadFile = result;
    }

    uploaderError(result) {
        this.errors.push({
            message: result,
            type: 'error'
        });
    }

    addToCart() {
        this.loading = true;

        this.service.printsAddToCart(this.model, this.quantity, this.uploadFile, this.comments).then(
            response => {
                this.loading = false;
                window.location.pathname = 'cart';
            },
            response => {
                this.loading = false;
            }
        );
    }

    initComplete() {
        // Small hack to prevent displaying not ready component
        if (!this.isReady) {
            this.isReady = true;
            this.translate.promise.then(() => {
                    const loadingContainer = document.getElementsByClassName('configurator-loading')[0];
                    loadingContainer.classList.add('configurator-loading-complete');
            });
        }
    }

    validateMainShape() {
        this.errors = [];

        if (!this.configuratorPrintsMainShapeParams.has(this.mainShape.type)) return false;

        const params = this.configuratorPrintsMainShapeParams.get(this.mainShape.type);

        if (!params.validators) return true;

        if (params.validators.length == 0) return true;

        const {w, h, ...localMainShapeModel} = this.mainShape;

        for (const validator of params.validators) {
            if (typeof validator != 'function') continue;

            const hasError = validator(localMainShapeModel);

            if (hasError) {
                const errorMessage = Array.isArray(hasError.message) ? this.translate.t(...hasError.message) : this.translate.t(hasError.message);

                if (hasError.hasOwnProperty('propName') && hasError.hasOwnProperty('propValue')) {
                    this.setLastProperMainShapeModelProperty(hasError.propName, hasError.propValue);
                }

                this.errors.push({
                    message: errorMessage,
                    type: 'error'
                });

                return false;
            }
        }

        return true;
    }

    validateMainShapeSize() {
        let width = this.mainShape.w;
        let height = this.mainShape.h;

        console.log('!validateMainShapeSize', width, height);

        if (width < 100 || height < 100) {
            this.errors.push({
                message: this.translate.t('configurator.errors.minimumSize', {minWidth: 100, minHeight: 100}), // Minimalny rozmiar materiału to 50*50mm.
                type: 'error'
            });

            return false;
        }

        const materialData = this.materialSettings.subType ? this.materialSettings.subType : this.materialSettings.type;

        // Maksymalny rozmiar elementu dla cięcia laserem i frezarką
        const shapeWithLaserAndFrezCutModeMaxWidth = ConfiguratorPrintsValidator.maximumCutModeLaserFrezSize.w;  // 2030
        const shapeWithLaserAndFrezCutModeMaxHeight = ConfiguratorPrintsValidator.maximumCutModeLaserFrezSize.h; // 3030

        // Maksymalny rozmiar elementu dla cięcia piłą + polerowanie
        const shapeWithChainPolishedCutModeMaxWidth = ConfiguratorPrintsValidator.maximumChainPolishedSize.w;    // 1990
        const shapeWithChainPolishedCutModeMaxHeight = ConfiguratorPrintsValidator.maximumChainPolishedSize.h;   // 1990

        // Maksymalny rozmiar materiału
        let shapeMaxWidth = ConfiguratorPrintsValidator.maximumMaterialSize.w;  // 2050
        let shapeMaxHeight = ConfiguratorPrintsValidator.maximumMaterialSize.h; // 3050

        /*** Ustalanie warunków walidacji ***/
        let validateMaxDimensions = {
            w: {type: 'globalShape', value: shapeMaxWidth},
            h: {type: 'globalShape', value: shapeMaxHeight}
        }

        const activeCutMode = this.getCutMode();

        // Ustalanie warunków dla cięcia laserem i frezarką
        if ((activeCutMode === 'laser' || activeCutMode === 'frez')) {
            if (validateMaxDimensions.w.value > shapeWithLaserAndFrezCutModeMaxWidth) {
                validateMaxDimensions.w = {type: 'shapeWithLaserAndFrezCutMode', value: shapeWithLaserAndFrezCutModeMaxWidth};
            }

            if (validateMaxDimensions.h.value > shapeWithLaserAndFrezCutModeMaxHeight) {
                validateMaxDimensions.h = {type: 'shapeWithLaserAndFrezCutMode', value: shapeWithLaserAndFrezCutModeMaxHeight};
            }
        } else if (activeCutMode === 'chainPolished') {
            if (validateMaxDimensions.w.value > shapeWithChainPolishedCutModeMaxWidth) {
                validateMaxDimensions.w = {type: 'shapeWithChainPolishedCutMode', value: shapeWithChainPolishedCutModeMaxWidth};
            }

            if (validateMaxDimensions.h.value > shapeWithChainPolishedCutModeMaxHeight) {
                validateMaxDimensions.h = {type: 'shapeWithChainPolishedCutMode', value: shapeWithChainPolishedCutModeMaxHeight};
            }
        }

        // Ustalanie warunków dla materiału z ustawionymi max. wymiarami w PA
        if (materialData && materialData.max_width && materialData.max_width < shapeMaxWidth) {
            shapeMaxWidth = materialData.max_width;
            otherShapeValidationErrorText = 'configurator.errors.maximumSize';
        }
        if (materialData && materialData.max_height && materialData.max_height < shapeMaxHeight) {
            shapeMaxHeight = materialData.max_height;
            otherShapeValidationErrorText = 'configurator.errors.maximumSize';
        }

        if (validateMaxDimensions.w.value > shapeMaxWidth) {
            validateMaxDimensions.w = {type: 'globalShape', value: shapeMaxWidth};
        }
        if (validateMaxDimensions.h.value > shapeMaxHeight) {
            validateMaxDimensions.h = {type: 'globalShape', value: shapeMaxHeight};
        }

        /*** Walidacja ***/
        console.log('validateMaxDimensions', validateMaxDimensions, width, height);

        // Walidacja materiału ciętego laserowo lub frezerką
        let cutModeError = false;

        if ((validateMaxDimensions.w.type === 'shapeWithLaserAndFrezCutMode' || validateMaxDimensions.w.type === 'shapeWithChainPolishedCutMode') && width > validateMaxDimensions.w.value) {
            this.setLastProperMainShapeModelProperty('w', validateMaxDimensions.w.value);
            cutModeError = true;
        }

        if ((validateMaxDimensions.h.type === 'shapeWithLaserAndFrezCutMode' || validateMaxDimensions.h.type === 'shapeWithChainPolishedCutMode') && height > validateMaxDimensions.h.value) {
            this.setLastProperMainShapeModelProperty('h', validateMaxDimensions.h.value);
            cutModeError = true;
        }

        let messageMaxWidthValue, messageMaxHeightValue = '';

        if (cutModeError) {
            let messageTranslationKey = '';
            switch (activeCutMode) {
                case 'laser':
                    messageTranslationKey = 'configurator.errors.maximumSizeLaserCut';
                    messageMaxWidthValue = shapeWithLaserAndFrezCutModeMaxWidth;
                    messageMaxHeightValue = shapeWithLaserAndFrezCutModeMaxHeight;
                    break;
                case 'frez':
                    messageTranslationKey = 'configurator.errors.maximumSizeFrezCut';
                    messageMaxWidthValue = shapeWithLaserAndFrezCutModeMaxWidth;
                    messageMaxHeightValue = shapeWithLaserAndFrezCutModeMaxHeight;
                    break;
                case 'chainPolished':
                    messageTranslationKey = 'configurator.errors.maximumSize';
                    messageMaxWidthValue = shapeWithChainPolishedCutModeMaxWidth;
                    messageMaxHeightValue = shapeWithChainPolishedCutModeMaxHeight;
            }

            this.errors.push({
                message: this.translate.t(messageTranslationKey, {
                    maxWidth: messageMaxWidthValue,
                    maxHeight: messageMaxHeightValue
                }), // Maksymalny rozmiar materiału to ${materialData.max_width}*${materialData.max_height}mm.,
                type: 'error'
            });
        }

        // Walidacja globalnego wymiaru materiału
        let otherShapeValidationErrorText = 'configurator.errors.maximumOtherShapeSize';
        let shapeError = false;

        if (validateMaxDimensions.w.type === 'globalShape' && width > validateMaxDimensions.w.value) {
            this.setLastProperMainShapeModelProperty('w', validateMaxDimensions.w.value);
            shapeError = true;
        }

        if (validateMaxDimensions.h.type === 'globalShape' && height > validateMaxDimensions.h.value) {
            this.setLastProperMainShapeModelProperty('h', validateMaxDimensions.h.value);
            shapeError = true;
        }

        if (shapeError) {
            this.errors.push({
                message: this.translate.t(otherShapeValidationErrorText, {
                    maxWidth: shapeMaxWidth,
                    maxHeight: shapeMaxHeight
                }),// Maksymalny rozmiar materiału dla wybranego kształtu to 2030*3030mm.,
                type: 'error'
            });
        }

        if (cutModeError || shapeError) {
            return false;
        }

        return true;
    }

    setLastProperMainShapeModelProperty(property, value) {

        console.log('!setLastProperMainShapeModelProperty', this.lastProperMainShapeModel, property, value);

        if (!this.lastProperMainShapeModel.hasOwnProperty(property)) {
            return false;
        }

        this.lastProperMainShapeModel[property] = value;
    }
}

let configuratorPrintsComponent = {
    bindings: {},
    template: configuratorPrintsHtml,
    controller: configuratorPrintsController
};

export default configuratorPrintsComponent;
